module.exports = __webpack_public_path__ + "img/HQ-OA-360V06NL-T.31fef8d7.jpg";